export default "__VITE_ASSET__DUuDqbNN__"